import type { Lighting_PoleRoadDetailsModel } from "src/graphql/types";

export const roadDetailsDefaultValues: Lighting_PoleRoadDetailsModel = {
  roadType: null as any,
  roadSurface: null as any,
  roadLightingClass: null as any,
  roadWidth: null as any,
  distanceFromRoadwayEdgeToPole: null as any,
};
